export default "__VITE_ASSET__DHsEntJQ__"